import { api } from '../api';

// Single-use invitation tokens. mint() returns one token per recipient email (or one
// generic token when no emails are given); resolve() reads a token for the signup
// screen (public). The token is consumed server-side on register.
export const invitesStore = {
  // → { invites: [{ email, token }] }
  mint({ orgId, mlsId, emails } = {}) {
    return api.post('/api/invites', { orgId, mlsId, emails });
  },
  // → { token, orgId, mlsId, email, orgName, mlsName, used, expired }
  resolve(token) {
    return api.get(`/api/invites/${encodeURIComponent(token)}`);
  },
};
